import { inject, computedFrom } from 'aurelia-framework';
import { DialogController } from 'aurelia-dialog';
import { ToolsService } from 'pages/utilities/tools/service';

@inject(DialogController, ToolsService)
export class ResetSandbox {
    constructor(controller, toolsService) {
        this.controller = controller;
        this.toolsService = toolsService;
        this.statusPollTimer = null;
        this.sandboxStatus = null;
        this.statusFetchError = null;
        this.postResetActive = false;
    }

    @computedFrom('sandboxStatus')
    get isSandboxOnline() {
        return this.sandboxStatus?.provisioningState === 'ONLINE';
    }

    detached() {
        this.stopStatusPolling();
    }

    stopStatusPolling() {
        if (this.statusPollTimer != null) {
            clearInterval(this.statusPollTimer);
            this.statusPollTimer = null;
        }
    }

    async fetchAndApplyStatus() {
        try {
            this.statusFetchError = null;
            const data = await this.toolsService.getSandboxStatus();
            this.sandboxStatus = data;
            if (this.isSandboxOnline) {
                this.stopStatusPolling();
            }
        } catch {
            this.statusFetchError = 'Unable to load sandbox status.';
        }
    }

    startStatusPolling() {
        this.stopStatusPolling();
        this.fetchAndApplyStatus();
        this.statusPollTimer = setInterval(() => this.fetchAndApplyStatus(), 5000);
    }

    async reset() {
        if (this.isRequesting) return;
        this.isRequesting = true;
        this.statusFetchError = null;
        try {
            await this.toolsService.resetSandbox();
            this.postResetActive = true;
            this.sandboxStatus = null;
            this.startStatusPolling();
        } finally {
            this.isRequesting = false;
        }
    }
}
